import React from "react";
import HeroSection from "./sections/HeroSection";
import PerformanceAndROI from "./sections/PerformanceAndROI";
import CTASection from "./sections/CTASection";
import MagicBento from "../components/MagicBento";
import "./css/HomePage.css";

// Advertiser Icons
// import EyeIcon from "../assets/Eye.png";
// import ClicksIcon from "../assets/ClicksIcon.png";
// import NewsPaperIcon from "../assets/NewsPaperIcon.png";
// import AdvertiserIcon01 from "../assets/Advertiser_01.png";
import AdvertiserIcon01 from "../assets/Mobile Marketing.gif";
import AdvertiserIcon02 from "../assets/Full inbox.gif";
import AdvertiserIcon03 from "../assets/Conversion rate optimization.gif";

// Publisher Icons
// import PublisherIcon01 from "../assets/Monetization Without Compromise.png";
// import PublisherIcon02 from "../assets/Revenue_Graph.png";
// import PublisherIcon03 from "../assets/Ads That Fit Naturally.png";
// import PublisherIcon04 from "../assets/Cleaner Pages.png";
// import PublisherIcon05 from "../assets/Ads Readers Don’t Hate.png";
// import PublisherIcon01 from "../assets/Publisher_01.png";
import PublisherIcon01 from "../assets/Revenue_01.gif";
// import PublisherIcon02 from "../assets/Publisher_02.png";
import PublisherIcon02 from "../assets/Wall post.gif";
// import PublisherIcon03 from "../assets/Publisher_03.png";
import PublisherIcon03 from "../assets/Price.gif";
// import PublisherIcon04 from "../assets/Publisher_04.png";
import PublisherIcon04 from "../assets/Revenue.gif";
// import PublisherIcon05 from "../assets/Publisher_05.png";
import PublisherIcon05 from "../assets/Generating new leads.gif";

const HomePage = () => {
  const advertiserCards = [
    {
      title: "Real attention. Real results.",
      description: "Connect with engaged readers — not wasted impressions.",
      // icon: EyeIcon,
      image: AdvertiserIcon01,
      className: "col-span-1"
    },
    {
      title: "Reach users, not just impressions",
      description: "Clean placements designed to drive action, not distraction.",
      // icon: ClicksIcon,
      image: AdvertiserIcon02,
      className: "col-span-1"
    },
    {
      title: "Designed for conversion, not clutter",
      description: "Your ads appear inside relevant news content, where attention already exists.",
      // icon: NewsPaperIcon,
      image: AdvertiserIcon03,
      className: "col-span-2 row-span-2 large-card"
    }
  ];

  const publisherCards = [
    {
      title: "Revenue that doesn’t ruin experience",
      description: "Generate revenue without sacrificing reader trust or content quality.",
      icon: PublisherIcon01,
      image: PublisherIcon01,
      className: "col-span-1"
    },
    {
      title: "Ads that fit, not interrupt",
      description: "Earn sustainably without disrupting how users read and engage.",
      // icon: PublisherIcon02,
      image: PublisherIcon02,
      className: "col-span-1"
    },
    {
      title: "Better ads, cleaner pages",
      description: "Placements that blend into content, not interrupt it.",
      // icon: PublisherIcon03,
      image: PublisherIcon03,
      className: "col-span-2"
    },
    {
      title: "Monetization without compromise",
      description: "Fewer distractions. Faster loads. Better reading flow.",
      // icon: PublisherIcon04,
      image: PublisherIcon04,
      className: "col-span-1"
    },
    {
      title: "Ads users don’t hate",
      description: "Relevant, respectful ads users are comfortable engaging with.",
      // icon: PublisherIcon05,
      image: PublisherIcon05,
      className: "col-span-1"
    }
  ];

  return (
    <div className="home-page">
      <HeroSection />

      {/* What Ravooka Delivers Section */}
      <section className="ravooka-delivers-section">
        <div className="ravooka-delivers-header">
          <h2 className="ravooka-delivers-title">Ads, done right!</h2>
          <p className="ravooka-delivers-subtext">Better ads, for everyone.</p>
        </div>

        <div className="dual-bento-container">
          {/* Advertiser Bento */}
          <div className="bento-column">
            <div className="bento-column-badge">
              <span className="bento-column-badge-text">For Advertisers</span>
            </div>
            <MagicBento
              cards={advertiserCards}
              enableStars={false}
              enableSpotlight={false}
              enableBorderGlow={true}
              textAutoHide={false}
              enableTilt={false}
              clickEffect={true}
              enableMagnetism={true}
            />
          </div>

          {/* Publisher Bento */}
          <div className="bento-column">
            <div className="bento-column-badge">
              <span className="bento-column-badge-text">For Publishers</span>
            </div>
            <MagicBento
              cards={publisherCards}
              enableStars={false}
              enableSpotlight={false}
              enableBorderGlow={true}
              textAutoHide={false}
              enableTilt={false}
              clickEffect={true}
              enableMagnetism={true}
              gridClassName="publisher-grid"
            />
          </div>
        </div>
      </section>

      {/* Performance and ROI Section */}
      <PerformanceAndROI />

      {/* CTA Section */}
      <CTASection />
    </div>
  );
};

export default HomePage;